"use client";

import { c as _c } from "react/compiler-runtime";
import { TableCell, TableRow } from "@/components/ui/table";
import { TLeaderboardListItem } from "@/types/types";
import { formatUserFullName } from "@/utils/formatters";
import { useAuth } from "@clerk/nextjs";
import Image from "next/image";
import Link from "next/link";
import PositionBadge from "./position-badge";
type LeaderboardListItemProps = {
  user: TLeaderboardListItem;
  index: number;
};
export default function LeaderboardListItem(t0) {
  const $ = _c(26);
  const {
    user,
    index
  } = t0;
  const {
    userId
  } = useAuth();
  const t1 = index + 1;
  let t2;
  if ($[0] !== t1) {
    t2 = <TableCell><PositionBadge position={t1} /></TableCell>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `/user/${user.clerkId}`;
  let t4;
  if ($[2] !== user.profile?.firstName || $[3] !== user.profile?.imageUrl || $[4] !== user.profile?.lastName) {
    t4 = user.profile?.imageUrl && <Image src={user.profile?.imageUrl} alt={`Profile picture of ${formatUserFullName(user.profile?.firstName, user.profile?.lastName)}`} width={32} height={32} />;
    $[2] = user.profile?.firstName;
    $[3] = user.profile?.imageUrl;
    $[4] = user.profile?.lastName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex size-8 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = user.profile?.firstName;
  const t7 = user.profile?.lastName;
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <p className="line-clamp-1">{t6} {t7}</p>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = user.clerkId === userId ? "\u26A1" : "";
  let t10;
  if ($[11] !== t9) {
    t10 = <div className="w-4"><span>{t9}</span></div>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <div className="flex items-center text-ellipsis text-sm">{t8}{t10}</div>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t3 || $[18] !== t5) {
    t12 = <TableCell className="px-0 md:px-4"><Link href={t3} className="flex items-center gap-3">{t5}{t11}</Link></TableCell>;
    $[16] = t11;
    $[17] = t3;
    $[18] = t5;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== user.monthlyScore) {
    t13 = <TableCell className="text-center text-sm">{user.monthlyScore} XP</TableCell>;
    $[20] = user.monthlyScore;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t2) {
    t14 = <TableRow>{t2}{t12}{t13}</TableRow>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t2;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}